<template>
  <section >
    <div class="l-shop l-shop--dark-grey pt-0">
      <div class="l-shop__head l-shop__head--pd pt-12">
        <div v-on:click="collback" class="l-shop__head--icon">
          <img src="/assets/images/icon/icon-back.svg" alt="">
        </div>
        <div class="l-shop__head--title l-shop__head--auto">{{title}}</div>
        <div class="l-shop__head--icon"></div>
      </div>
    </div>
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";

export default Vue.extend({
  name: 'headTitle',
  props: ['title','collback'],
  components: {
  },
  async created() {
  },
  data() {
    return {
    }
  },
  computed: {
  }
})
</script>